<template>
    <client-page class="app--main">
        <!-- S: 메인링크 -->
        <main-link />
        <!-- E: 메인링크 -->

        <!-- S: e커머스피칭페스타 -->
        <main-section id="efesta" title="e커머스피칭페스타">
            <v-img contain max-width="230" src="/images/main/section-number-1.png" class="main-section__number" />

            <main-section class="py-0">
                <template #mainSectionImmersive>
                    <tit-bar>
                        <template #title>경진대회를 통한 혁신성장 생태계 조성</template>
                        <template #text>
                            유통물류서비스에 적용 가능한 혁신 기술을 보유한 기업을 발굴하여<br class="d-none d-lg-block" />
                            투자유치 기회 제공 및 사업홍보 지원 
                        </template>
                        <template #button>
                            <v-btn x-large outlined color="secondary" to="/pitching-festa" class="min-w-140px min-w-lg-180px justify-space-between">
                                더 보기
                                <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                            </v-btn>
                        </template>
                    </tit-bar>

                    <v-card outlined class="border-light text-center" data-aos="fade" data-aos-delay="100">
                        <v-row no-gutters justify="center">
                            <v-col cols="6" md="4">
                                <div class="px-12px py-20px py-md-40px py-lg-60px">
                                    <div class="mb-20px mb-md-40px">
                                        <v-img :max-width="$vuetify.breakpoint.mdAndUp ? 160 : 90" :aspect-ratio="1 / 1" src="/images/main/main-pitching-festa-icon.png" class="mx-auto" />
                                    </div>
                                    <div class="tit tit--xxs break-keep">유통사·투자사·기술사 <br class="d-none d-md-block" />대상 피칭</div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="auto" class="d-none d-md-block ml-md-n1px align-self-stretch">
                                <div class="h-100 py-40px py-lg-60px"><v-divider vertical class="h-100" /></div>
                            </v-col>
                            <v-col cols="6" md="4">
                                <div class="px-12px py-20px py-md-40px py-lg-60px">
                                    <div class="mb-20px mb-md-40px">
                                        <v-img :max-width="$vuetify.breakpoint.mdAndUp ? 160 : 90" :aspect-ratio="1 / 1" src="/images/main/main-pitching-festa-icon2.png" class="mx-auto" />
                                    </div>
                                    <div class="tit tit--xxs break-keep">네트워킹</div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="auto" class="d-none d-md-block ml-md-n1px align-self-stretch">
                                <div class="h-100 py-40px py-lg-60px"><v-divider vertical class="h-100" /></div>
                            </v-col>
                            <v-col cols="6" md="4">
                                <div class="px-12px py-20px py-md-40px py-lg-60px">
                                    <div class="mb-20px mb-md-40px">
                                        <v-img :max-width="$vuetify.breakpoint.mdAndUp ? 160 : 90" :aspect-ratio="1 / 1" src="/images/main/main-pitching-festa-icon3.png" class="mx-auto" />
                                    </div>
                                    <div class="tit tit--xxs break-keep">사업홍보를 위한 <br class="d-none d-md-block" />스타트업 부스지원</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </template>
            </main-section>

            <main-section class="pb-0">
                <template #mainSectionImmersive>
                    <tit-bar>
                        <template #title>성과</template>
                    </tit-bar>

                    <v-card outlined class="border-light text-center" data-aos="fade" data-aos-delay="100">
                        <v-row no-gutters justify="center">
                            <v-col cols="6" md="4">
                                <div class="px-12px py-20px py-md-40px py-lg-60px">
                                    <div class="mb-20px mb-md-40px">
                                        <v-img :max-width="$vuetify.breakpoint.mdAndUp ? 160 : 90" :aspect-ratio="1 / 1" src="/images/main/main-pitching-festa-icon4.png" class="mx-auto" />
                                    </div>
                                    <div class="tit tit--xxs mb-6px mb-md-10px">발굴기업</div>
                                    <div class="d-flex align-center justify-center txt txt--sm txt--dark line-height-1">
                                        <span class="pr-4px pr-md-8px">총</span>
                                        <strong class="font-size-24 font-size-md-40 font-size-lg-56 line-height-1 primary--text">203</strong>
                                        <span class="pl-4px pl-md-8px">개사</span>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="auto" class="d-none d-md-block ml-md-n1px align-self-stretch">
                                <div class="h-100 py-40px py-lg-60px"><v-divider vertical class="h-100" /></div>
                            </v-col>
                            <v-col cols="6" md="4">
                                <div class="px-12px py-20px py-md-40px py-lg-60px">
                                    <div class="mb-20px mb-md-40px">
                                        <v-img :max-width="$vuetify.breakpoint.mdAndUp ? 160 : 90" :aspect-ratio="1 / 1" src="/images/main/main-pitching-festa-icon5.png" class="mx-auto" />
                                    </div>
                                    <div class="tit tit--xxs mb-6px mb-md-10px">투자금액</div>
                                    <div class="d-flex align-center justify-center txt txt--sm txt--dark line-height-1">
                                        <span class="pr-4px pr-md-8px">총</span>
                                        <strong class="font-size-24 font-size-md-40 font-size-lg-56 line-height-1 primary--text">1,884</strong>
                                        <span class="pl-4px pl-md-8px">억원</span>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="auto" class="d-none d-md-block ml-md-n1px align-self-stretch">
                                <div class="h-100 py-40px py-lg-60px"><v-divider vertical class="h-100" /></div>
                            </v-col>
                            <v-col cols="6" md="4">
                                <div class="px-12px py-20px py-md-40px py-lg-60px">
                                    <div class="mb-20px mb-md-40px">
                                        <v-img :max-width="$vuetify.breakpoint.mdAndUp ? 160 : 90" :aspect-ratio="1 / 1" src="/images/main/main-pitching-festa-icon6.png" class="mx-auto" />
                                    </div>
                                    <div class="tit tit--xxs mb-6px mb-md-10px">사업협업연계</div>
                                    <div class="d-flex align-center justify-center txt txt--sm txt--dark line-height-1">
                                        <span class="pr-4px pr-md-8px">총</span>
                                        <strong class="font-size-24 font-size-md-40 font-size-lg-56 line-height-1 primary--text">50</strong>
                                        <span class="pl-4px pl-md-8px">개사</span>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </template>
            </main-section>

            <main-section class="pb-0">
                <template #mainSectionImmersive>
                    <tit-bar>
                        <template #title>연도별 수상기업</template>
                        <template #button>
                            <v-btn x-large outlined color="secondary" to="/pitching-festa/startup" class="min-w-140px min-w-lg-180px justify-space-between">
                                더 보기
                                <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                            </v-btn>
                        </template>
                    </tit-bar>

                    <div class="logo-slide">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div v-for="award in awards" :key="award?._id" class="swiper-slide">
                                    <v-card outlined class="border-light">
                                        <div class="logo-slide__img" :style="`background-image:url(${award?.image?.src})`" @click="move(award)"/>
                                    </v-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </main-section>
        </main-section>
        <!-- E: e커머스피칭페스타 -->

        <!-- S: 유통데이터 활용 경진대회 -->
        <main-section id="circulation" title="유통데이터 활용 경진대회" class="secondary white--text">
            <v-img contain max-width="230" src="/images/main/section-number-2.png" class="main-section__number" />

            <main-section class="py-0">
                <template #mainSectionImmersive>
                    <tit-bar>
                        <template #title>데이터를 활용한 새로운 전략 제시</template>
                        <template #text>
                            <span class="white--text">유통데이터 서비스 플랫폼에서 제공하는 데이터를 활용하여 <br class="d-none d-lg-block">
                            유통산업의 새로운 전략을 제시할 수 있는 사례를 발굴/공유</span>
                        </template>
                        <template #button>
                            <v-btn x-large outlined color="white" to="/circulation" class="min-w-140px min-w-lg-180px justify-space-between">
                                더 보기
                                <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                            </v-btn>
                        </template>
                    </tit-bar>

                    <div data-aos="fade" data-aos-delay="200">
                        <v-img max-width="460" :aspect-ratio="672 / 2586" src="/images/main/main-circulation-img-mo.png" class="d-md-none mx-auto" />
                        <v-img :aspect-ratio="1200 / 632" src="/images/main/main-circulation-img.png" class="d-none d-md-block" />
                    </div>
                </template>
            </main-section>

            <main-section class="pb-0">
                <template #mainSectionImmersive>
                    <tit-bar>
                        <template #title>연도별 수상작</template>
                        <template #button>
                            <v-btn x-large outlined color="white" to="/circulation/data" class="min-w-140px min-w-lg-180px justify-space-between">
                                더 보기
                                <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                            </v-btn>
                        </template>
                    </tit-bar>

                    <div class="pb-24px">
                        <h3 class="tit tit--xxs" data-aos="fade-right" data-aos-delay="300">2022년도</h3>
                        <v-divider class="border-2 white mt-10px" data-aos="fade" data-aos-delay="300" />
                    </div>

                    <v-row class="row--lg">
                        <v-col cols="12" sm="6" md="4" data-aos="fade-up" data-aos-delay="400">
                            <v-card min-height="170" class="border-light" to="/circulation/data/64d32da6182f802bee8a1f8c">
                                <div class="pa-16px pa-md-24px">
                                    <v-img max-width="32" :aspect-ratio="1 / 1" src="/images/main/main-circulation-icon.png" class="mb-6px" />
                                    <h3 class="tit tit--xxs mb-6px mb-md-10px">AIVLE</h3>
                                    <div class="txt txt--sm">코로나 시대에 따른 소비 패턴의 변화와 이에 대응하는 유통/판매 전략 수립 방안</div>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" data-aos="fade-up" data-aos-delay="500">
                            <v-card min-height="170" class="border-light" to="/circulation/data/64d33f4b182f802bee8a2124">
                                <div class="pa-16px pa-md-24px">
                                    <v-img max-width="32" :aspect-ratio="1 / 1" src="/images/main/main-circulation-icon.png" class="mb-6px" />
                                    <h3 class="tit tit--xxs mb-6px mb-md-10px">내일은 분석왕</h3>
                                    <div class="txt txt--sm">소비자 선호를 기반한 전략적 과일묶기</div>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="12" md="4" data-aos="fade-up" data-aos-delay="600">
                            <v-card min-height="170" class="border-light" to="/circulation/data/64d345fb182f802bee8a21a0">
                                <div class="pa-16px pa-md-24px">
                                    <v-img max-width="32" :aspect-ratio="1 / 1" src="/images/main/main-circulation-icon.png" class="mb-6px" />
                                    <h3 class="tit tit--xxs mb-6px mb-md-10px">구칠스타</h3>
                                    <div class="txt txt--sm">오팔세대 맞춤형 상품 개발</div>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
            </main-section>
        </main-section>
        <!-- E: 유통데이터 활용 경진대회 -->

        <!-- S: 유통데이터 활용 교육·법률지원 -->
        <main-section title="유통데이터 활용 교육∙법률지원" class="main-section--last main-section--education">
            <template #mainSectionImmersive>
                <div class="main-section__bg" style="background-image:url(/images/main/main-education-bg.png)" />
            </template>
            <v-img contain max-width="230" src="/images/main/section-number-3.png" class="main-section__number" />

            <main-section class="py-0">
                <template #mainSectionImmersive>
                    <tit-bar>
                        <template #title>유통데이터 활용 교육 소개</template>
                        <template #button>
                            <v-btn x-large outlined color="secondary" to="/education" class="min-w-140px min-w-lg-180px justify-space-between">
                                더 보기
                                <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                            </v-btn>
                        </template>
                    </tit-bar>

                    <v-row class="row--xl">
                        <v-col cols="12" sm="6" data-aos="fade-up" data-aos-delay="300">
                            <v-card outlined class="border-light">
                                <v-img :aspect-ratio="568 / 378" src="/images/main/main-education-img.jpg" />
                                <v-divider class="border-light" />
                                <div class="pa-20px pa-md-30px">
                                    <h3 class="tit tit--xs mb-6px mb-md-10px">온라인 플랫폼 교육</h3>
                                    <div class="txt txt--lg">기술기업이 유통물류에 적용 가능한 리테일 기술 개발 시 <br class="d-none d-xl-block" />유통시장에 빠르게 진출할 수 있도록 온라인 커머스에 대한 <br class="d-none d-xl-block" />이해력 제고</div>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" data-aos="fade-up" data-aos-delay="400">
                            <v-card outlined class="border-light">
                                <v-img :aspect-ratio="568 / 378" src="/images/main/main-education-img2.jpg" />
                                <v-divider class="border-light" />
                                <div class="pa-20px pa-md-30px">
                                    <h3 class="tit tit--xs mb-6px mb-md-10px">유통데이터 활용 교육</h3>
                                    <div class="txt txt--lg">유통물류, 제조, IT기업 대상 다양한 데이터를 활용하여 <br class="d-none d-xl-block" />비즈니스 전략 수립과 수요 예측, 마케팅, 데이터 분석 등 데이터 <br class="d-none d-xl-block" />활용 이해도 증진</div>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
            </main-section>

            <main-section class="pb-0">
                <template #mainSectionImmersive>
                    <tit-bar>
                        <template #title>유통데이터 활용 법률 자문 지원</template>
                        <template #button>
                            <v-btn x-large outlined color="secondary" to="/education/law" class="min-w-140px min-w-lg-180px justify-space-between">
                                더 보기
                                <icon-arrow-rounded direction="right" class="icon--size-small ml-12px" />
                            </v-btn>
                        </template>
                    </tit-bar>

                    <v-card img="/images/main/main-education-img3.jpg" class="white--text" data-aos="fade" data-aos-delay="300">
                        <v-responsive :aspect-ratio="1200 / 400">
                            <div class="d-flex h-100">
                                <div class="px-20px pt-60px pb-20px px-md-40px pb-md-40px mt-auto">
                                    <h3 class="tit tit--xs mb-6px mb-md-10px">유통데이터 활용 기업 대상 법률 지원체계구축</h3>
                                    <div class="txt txt--lg white--text">유통데이터를 수집·가공·제공 등 활용하는 과정에서 수반되는 법률적 쟁점을 사전 발굴·검토하여 <br class="d-none d-xl-block" />리스크를 방지하고 수시로 발생하는 법적 이슈를 신속하고 효율적으로 지원</div>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </main-section>

            <main-section class="pb-0">
                <template #mainSectionImmersive>
                    <v-row>
                        <v-col cols="12" md="6">
                            <main-applications />
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="pt-60px pt-lg-0 pl-lg-60px">
                                <div class="tit-wrap">
                                    <v-row>
                                        <v-col cols="auto" data-aos="fade-right" data-aos-delay="100">
                                            <h3 class="tit tit--bar">공지사항</h3>
                                        </v-col>
                                        <v-spacer />
                                        <v-col cols="auto" class="text-right" data-aos="fade-left" data-aos-delay="100">
                                            <v-btn icon tile outlined color="grey" to="/center/notice">
                                                <v-icon size="24">mdi-plus</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </div>

                                <main-notice />
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </main-section>
        </main-section>
        <!-- E: 유통데이터 활용 교육·법률지원 -->

        <!-- <v-row justify="center">
            <v-col cols="12" align="center" class="py-0">
                <span class="subtitle-1 font-weight-bold">다국어 샘플</span> <br>
                <span class="caption">(해당 내용은 테스트하고 지우면되요)</span>
            </v-col>
            <v-col cols="auto" class="py-0">
                <locale-select label="언어변경"></locale-select>
            </v-col>
            <v-col cols="12" align="center">
                <div> 한국어 번역 경로: src/locales/ko.js </div>
                <div> 영어 번역 경로: src/locales/en.js </div>
                <div> 중국어 번역 경로: src/locales/cn.js </div>
                <div class="mt-4"> 사용법 $t() 함수 안에, src/locales/{locale}.js 에서 작성한 json 키워드 나열 </div>
                <div class="font-weight-bold mt-4">JSON 작성법1</div>
                <div>
                    {
                        "key1": "value1"
                    }
                </div>
                <div class="font-weight-bold mt-4">JSON 작성법2</div>
                <div>
                    {
                        "key1": {
                            "key2": "value2"
                        }
                    }
                </div>
                <div class="font-weight-bold mt-4">JSON 작성법3 - 우리 회사 룰 대략 아래처럼 정하죠 </div>
                <div>
                    {
                        page: {
                            section1: "내용1",
                            section2: {
                                title: "타이틀",
                                content: "내용"
                            }
                        }
                    }
                </div>
                <div class="mt-4">
                    <div class="subtitle-1 font-weight-bold">example1</div>
                    <div class="body-1">$t("common.로그인")</div>
                    <div class="blue--text font-weight-bold">결과: {{ $t("common.로그인") }}</div>
                </div>
                <div class="mt-4">
                    <div class="subtitle-1 font-weight-bold">example2</div>
                    <div class="body-1">$t("main.section1")</div>
                    <div class="blue--text font-weight-bold">결과: {{ $t("main.section1") }}</div>
                </div>
                <div class="mt-4">
                    <div class="subtitle-1 font-weight-bold">example3</div>
                    <div class="body-1">$t("main.section2.title")</div>
                    <div class="body-1">$t("main.section2.content")</div>
                    <div class="blue--text font-weight-bold">결과: {{ $t("main.section2.title") }}</div>
                    <div class="blue--text font-weight-bold">결과: {{ $t("main.section2.content") }}</div>
                </div>
            </v-col>
        </v-row> -->

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import api from "@/api";
import Swiper from "swiper/bundle";

import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

// import LocaleSelect from "@/components/client/inc/locale-select.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";
import TitBar from "@/components/dumb/tit-bar.vue";
import MainSection from "@/components/client/main/main-section.vue";
import MainLink from "@/components/client/main/main-link.vue";
import MainApplications from "@/components/client/main/main-applications.vue";
import MainNotice from "@/components/client/main/main-notice.vue";

export default {
    components: {
        // LocaleSelect,
        ClientPage,
        PopupLayer,
        IconArrowRounded,
        TitBar,
        MainSection,
        MainLink,
        MainApplications,
        MainNotice,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data() {
        return {
            festa: null,

            categoriesYoutube,
            categoriesReport,
            categoriesForms,

            awards: null
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { festa } = await api.v1.kea.festa.get();
            this.festa = festa;

            let { awards } = await api.v1.main.award.gets();
            this.awards = awards;

            this.$nextTick(() => {
                this.Swiper = new Swiper(".logo-slide .swiper-container", {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    centeredSlides: false,
                    speed: 500,
                    loop: true,
                    autoplay: true,
                    breakpoints: {
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                        },
                    },
                });
            });
        },
        move(award) {
            if(award.link) {
                location.href = award.link
            } else {
                return
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.logo-slide {
    .swiper-container {
        overflow: visible;
    }
    &__img {
        width: 100%;
        padding-top: calc(98 / 280 * 100%);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }
}

.main-section--education {
    .main-section {
        &__bg {
            top: auto;
            bottom: 0;
            height: auto;
            padding-top: calc(280 / 1920 * 100%);
        }
    }
}
</style>
